import type { ComponentStyleConfig } from '@chakra-ui/theme';

export const styleConfig: ComponentStyleConfig = {
  parts: ['title', 'subtitle', 'wrapper'],
  baseStyle: {
    wrapper: {},
    title: {},
    subtitle: {},
  },
  sizes: {
    default: {
      wrapper: {},
      title: {},
      subtitle: {},
    },
    small: {
      wrapper: {},
      title: {},
      subtitle: {},
    },
  },
  defaultProps: {
    size: 'default',
  },
};
